<template>
  <div class="row custom-form-wrapper">
    <div class="col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1">
      <div class="custom-form app-res">
        <div class="panel-body">
          <div class="panel panel-info app-search-header-panel">
            <div class="row app-search-wrapper">
              <div class="col-md-10 col-md-offset-1">
                <div class="app-search-header">
                  <div class="row app-search-header-row">
                    <div class="col-md-4 header-left">
                      <span>Select City</span>
                    </div>
                    <div class="col-md-6 header-middle">
                      <select
                        id="filterSelect"
                        name="filterSelect"
                        @change="getFormDataBySelect"
                        v-model.trim="filterSelect"
                        class="form-control"
                      >
                        <option></option>
                        <option
                          v-for="item in cityList"
                          v-bind:value="item.value"
                          :key="item.value"
                          >{{ item.label }}</option
                        >
                      </select>
                    </div>
                    <div class="col-md-2 header-right">
                      <span
                        v-if="aniLabelsLoading"
                        class="fa fa-spinner fa-spin fa-2x fa-fw"
                      ></span>
                    </div>
                  </div>
                  <div class="row app-search-header-row">
                    <div
                      class="col-md-6 col-md-offset-3 app-search-header-btn-add"
                    >
                      <button
                        @click="newFormData"
                        type="submit"
                        class="btn btn-success"
                      >
                        Add New City
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-body">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h3 class="panel-title">City details</h3>
            </div>

            <div class="panel-body">
              <div
                class="form-group"
                v-bind:class="{ 'has-error': errors.has('cty_Name') }"
              >
                <label for="cty_Name">City name</label>
                <input
                  id="cty_Name"
                  name="cty_Name"
                  v-model.trim="fdata.cty_Name"
                  v-validate.initial="{ required: true, max: 100 }"
                  maxlength="100"
                  class="form-control"
                />
                <span class="help-block">{{ errors.first("cty_Name") }}</span>
              </div>

              <div
                class="form-group"
                v-bind:class="{ 'has-error': errors.has('cty_Highlights') }"
              >
                <label for="cty_Highlights">City highlights</label>
                <textarea
                  id="cty_Highlights"
                  name="cty_Highlights"
                  v-model.trim="fdata.cty_Highlights"
                  v-validate="{ max: 2000 }"
                  maxlength="2000"
                  rows="4"
                  class="form-control"
                ></textarea>
                <span class="help-block">{{
                  errors.first("cty_Highlights")
                }}</span>
              </div>

              <div
                class="form-group"
                v-bind:class="{ 'has-error': errors.has('cty_SortValue') }"
              >
                <label for="cty_SortValue">Sort value</label>
                <input
                  id="cty_SortValue"
                  name="cty_SortValue"
                  v-model.trim="fdata.cty_SortValue"
                  v-validate="{ numeric: true }"
                  maxlength="10"
                  class="form-control"
                />
                <span class="help-block">{{
                  errors.first("cty_SortValue")
                }}</span>
              </div>

              <div
                class="form-group"
                v-bind:class="{ 'has-error': errors.has('cty_Status') }"
              >
                <label for="cty_Status">Status</label>
                <select
                  id="cty_Status"
                  name="cty_Status"
                  v-model="fdata.cty_Status"
                  v-validate.initial="{ required: true }"
                  class="form-control"
                >
                  <option></option>
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                  <option value="90">Delete</option>
                </select>
                <span class="help-block">{{ errors.first("cty_Status") }}</span>
              </div>
            </div>

            <div class="btn-submit-wrapper">
              <div v-if="showAnimation" class="app-animation">
                <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
                <span class="text">Form submission in progress</span>
              </div>
              <button
                v-on:click="saveFormData"
                type="submit"
                class="btn btn-success"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <div>
          <modal
            name="alert-dialog-city"
            :width="400"
            :height="'auto'"
            :clickToClose="false"
          >
            <div class="panel-primary">
              <div class="panel-heading modal-alert-heading">
                <span class="modal-alert-title">Information</span>
                <button
                  @click="closeAlertDialog"
                  type="button"
                  class="close pull-right"
                >
                  <span
                    class="fa fa-times-circle modal-alert-close-button-icon"
                  ></span>
                </button>
              </div>
              <div class="panel-body modal-alert-body">
                <div class="modal-alert-text-wrapper">
                  <span
                    class="fa fa-exclamation-circle modal-alert-icon"
                  ></span>
                  <span class="modal-alert-text">
                    {{ alertMessage }}
                  </span>
                </div>
                <div class="modal-alert-footer">
                  <button
                    @click="closeAlertDialog"
                    type="button"
                    class="btn btn-default"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        cty_Name: "",
        cty_Highlights: "",
        cty_SortValue: null,
        cty_Status: null
      },
      showAnimation: false,
      alertMessage: "",
      cityList: [],
      filterSelect: "",
      aniLabelsLoading: false
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    saveFormData: async function() {
      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-city");
        return;
      }
      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}SaveFormData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData.status != 0) {
        this.showAnimation = false;
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-city");
        return;
      }
      if (!this.fdata.pkey) {
        this.resetFormData();
      }
      await this.getCityList();
      this.alertMessage = "Form submitted successfully";
      this.$modal.show("alert-dialog-city");
      this.showAnimation = false;
    },

    getFormDataBySelect: async function() {
      if (!this.filterSelect) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.filterSelect }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetFormDataBySelect`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.fdata, rData);
      }
      this.aniLabelsLoading = false;
    },

    getCityList: async function() {
      this.aniLabelsLoading = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetCityList`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        Object.assign(this.cityList, rData);
      }
      this.aniLabelsLoading = false;
    },

    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-city");
    },
    newFormData: function() {
      this.resetFormData();
      this.filterSelect = "";
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        pkey: 0,
        cty_Name: "",
        cty_Highlights: "",
        cty_SortValue: null,
        cty_Status: null
      });
    }
  },
  async mounted() {
    await this.getCityList();
  }
};
</script>
